module.exports = __webpack_public_path__ + "static/media/0a9b9cc6-55eb-4369-97ed-87b3eefd433a.f316d3f9.woff2";